export interface VendorType {
  vendor_id?: number;
  type_id?: number;
  type?: string;
  created_date?: Date;
  modified_date?: Date;
  isChecked?: boolean;
}

export const vendor_type_list = [
  {
    type_id: 1,
    type: "Printer",
    isChecked: false,
  },
  {
    type_id: 2,
    type: "Logistics",
    isChecked: false,
  },
  {
    type_id: 3,
    type: "Product Supplier",
    isChecked: false,
  },
];
